module.exports = __webpack_public_path__ + "fa-solid-900.woff2?893b3ef2bc8b4d8979798fb3b28132bd";